<div
  class="flex ms-small-b font-body-1 light-type"
  [ngClass]="{
    'flex--space-between': progressText && targetText,
    'flex--start': !targetText,
    'flex--end': !progressText
  }"
  *ngIf="progressText || targetText"
  aria-hidden="true"
>
  <span *ngIf="progressText">{{ progressText }}</span>
  <span *ngIf="targetText">{{ targetText }}</span>
</div>
<div
  class="progress-indicator grey-200-bg relative"
  role="progressbar"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="percentage"
  [attr.aria-label]="ariaLabel"
>
  <div
    [@fillGrow]="{ value: progressScaleX, params: { progress: progressScaleX } }"
    class="progress-fill relative {{ fillColor }}"
  ></div>
</div>
<div class="flex flex--center ms-small-t font-body-1 light-type hide-empty">
  <ng-content></ng-content>
</div>
